import React from "react";
import "../ArmatControlLanding.css";
import { Helmet } from "react-helmet-async";
import logo from "../assets/logos/logo-armat-control.webp";
import hero from "../assets/images/hero.webp";
import solucion from "../assets/images/solucion.png";
import paso01 from "../assets/images/1.png";
import paso02 from "../assets/images/2.png";
import paso03 from "../assets/images/3.png";
import paso04 from "../assets/images/4.png";
import paso05 from "../assets/images/5.png";
import trazabilidad from "../assets/images/trazabilidad.png";
import guardia from "../assets/images/guardia-armat.webp";
import barrios from "../assets/images/barrios.png";
import consorcios from "../assets/images/consorcios.png";
import industrias from "../assets/images/industrias.png";
import logistica from "../assets/images/logistica.png";
import empresas from "../assets/images/empresas.png";
import clinicas from "../assets/images/clinicas.png";

const CONTACT = {
  phone: "+54 9 11 0000 0000", 
  phoneHref: "+5491100000000",
  email: "contacto@armatseguridad.com", 
};

const steps = [
  { n: "01", title: "Generar pase", text: "El responsable carga los datos del visitante.", image: paso01 },
  { n: "02", title: "Código QR", text: "El sistema genera un pase digital con QR.", image: paso02 },
  { n: "03", title: "Visitante", text: "El visitante presenta el QR al llegar.", image: paso03 },
  { n: "04", title: "Validar acceso", text: "El guardia escanea y valida el ingreso.", image: paso04 },
  { n: "05", title: "Registro", text: "El evento queda registrado para consulta.", image: paso05 },
];

const icon = (d) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{d}</svg>
);

const usoIcons = {
  casa: icon(<><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/></>),
  edificio: icon(<><rect x="5" y="3" width="14" height="18"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2"/></>),
  fabrica: icon(<><path d="M3 21V11l5 3V11l5 3V5h4v16z"/><path d="M3 21h18"/><path d="M7 17h2M12 17h2"/></>),
  camion: icon(<><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></>),
  oficina: icon(<><rect x="4" y="3" width="10" height="18"/><path d="M14 9h6v12h-6"/><path d="M7 7h1M10 7h1M7 11h1M10 11h1M7 15h1M10 15h1"/></>),
  clinica: icon(<><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></>),
};

const uses = [
  ["Barrios privados", barrios, "casa", "recortar"], ["Consorcios", consorcios, "edificio", "recortar"], ["Industrias", industrias, "fabrica"],
  ["Centros logísticos", logistica, "camion"], ["Empresas", empresas, "oficina"], ["Clínicas", clinicas, "clinica"],
];

const YOUTUBE_URL = "https://www.youtube.com/watch?v=Ia3g04PPti0";
const YOUTUBE_COMO_FUNCIONA_URL = "https://www.youtube.com/watch?v=Ztk5T8S1FDY";

export default function ArmatControlLanding() {

  return (
    <>
      <Helmet>
        <title>Armat Control | Control de Accesos y Gestión de Visitas</title>
        <meta name="description" content="Sistema de control de accesos con QR, registro de visitas y traza. Una solución de Armat03 para gestionar ingresos de forma segura y ordenada." />
      </Helmet>
    
    <main className="ac-page">
      <section className="ac-hero">
        <img className="ac-hero__photo" src={hero} alt="Guardia operando un control de acceso digital" />
        <div className="ac-hero__shade" />
        <div className="ac-shell ac-hero__content">
          <img className="ac-logo ac-logo--hero" src={logo} alt="Armat Control" />
          <p className="ac-eyebrow">CONTROL DE ACCESOS INTELIGENTE</p>
          <h1>Más control.<br/><span>Menos incertidumbre.</span></h1>
          <p className="ac-lead">Una solución para gestionar accesos de forma simple, trazable y segura.</p>
          <a className="ac-btn" href={YOUTUBE_URL} target="_blank" rel="noreferrer">Conocé Armat Control<span>→</span></a>
        </div>
      </section>

      <section className="ac-problem ac-section">
        <div className="ac-shell ac-two-col">
          <div>
            <h2>Cuando el control de ingresos depende de la memoria,<br/><span>la información disminuye y el riesgo aumenta </span></h2>
            <p>Planillas incompletas, autorizaciones informales y falta de trazabilidad generan errores y pérdida de control.</p>
          </div>
          <div className="ac-risk-list">
            {["Autorizaciones informales","Registros incompletos","Sin trazabilidad","Decisiones sin respaldo"].map((x,i)=><div key={x}><b>{String(i+1).padStart(2,"0")}</b><span>{x}</span></div>)}
          </div>
        </div>
      </section>

      <section className="ac-solution ac-section">
        <div className="ac-shell ac-two-col ac-two-col--solution">
          <div>
            <h2 className="ac-solution__title">Armat <span>Control</span></h2>
            <p className="ac-subtitle">Control de accesos simple. Seguro. Trazable.</p>
            <p>Una herramienta desarrollada para ordenar y digitalizar el ingreso de personas, sin complejizar la operación.</p>
            <ul className="ac-checks">
              <li>Registro digital de accesos</li><li>Validación mediante QR</li><li>Historial de eventos</li><li>Información disponible en tiempo real</li>
            </ul>
          </div>
          <div className="ac-device-wrap"><img className="ac-device-img" src={solucion} alt="Vista del sistema Armat Control en computadora y teléfono" /></div>
        </div>
      </section>

      <section id="como-funciona" className="ac-how ac-section">
        <div className="ac-shell">
          <p className="ac-kicker">CÓMO FUNCIONA</p><h2>En <span>5 pasos</span></h2>
          <div className="ac-steps">
            {steps.map((s)=><article className="ac-step" key={s.n}>
              <div className="ac-step__circle"><img src={s.image} alt="" /></div>
              <b className="ac-step__n">{s.n}</b><h3>{s.title}</h3><p>{s.text}</p>
            </article>)}
          </div>
          <div className="ac-info-band">La información queda disponible en tiempo real para consulta y auditoría.<span>✓ Registro &nbsp; ✓ Trazabilidad &nbsp; ✓ Control</span>
            <a className="ac-btn ac-info-band__btn" href={YOUTUBE_COMO_FUNCIONA_URL} target="_blank" rel="noreferrer">Ver cómo funciona<span>→</span></a>
          </div>
        </div>
      </section>

      <section className="ac-trace ac-section">
        <div className="ac-shell ac-two-col">
          <div><p className="ac-kicker">TRAZABILIDAD</p><h2>Todo queda <br/><span>registrado.</span></h2><p>Cada acceso genera información que puede ser consultada posteriormente.</p>
            <ul className="ac-checks"><li>Quién ingresó</li><li>Cuándo</li><li>Quién autorizó</li><li>Qué guardia validó el acceso</li></ul>
          </div>
          <div className=""><img className="ac-trace-img" src={trazabilidad} alt="Panel de trazabilidad de Armat Control" /></div>
        </div>
      </section>

      <section className="ac-security ac-section">
        <div className="ac-shell ac-security__grid">
          <div className="ac-security__photo"><img src={guardia} alt="Guardia de Armat03" /></div>
          <div><h2>Desarrollado desde la <br/><span>experiencia en seguridad.</span></h2><p>Armat Control nace desde la operación diaria de seguridad.</p><p> La tecnología acompaña al personal. No lo reemplaza. </p><blockquote>“Tecnología aplicada a procesos reales de seguridad.”</blockquote></div>
        </div>
      </section>

      <section className="ac-uses ac-section">
        <div className="ac-shell ac-two-col">
          <div className="ac-uses__text"><h2>Una solución <br/><span>adaptable.</span></h2>
          <p>Armat Control puede implementarse en distintos entornos.</p></div>
          <div className="ac-use-grid">{uses.map(([name,img,ic,crop])=><article key={name}><img src={img} alt="" className={crop ? "ac-use-grid__img--recortar" : ""}/><div className="ac-use-grid__label"><i>{usoIcons[ic]}</i><span>{name}</span></div></article>)}</div>
        </div>
      </section>

      <section className="ac-cta ac-section">
        <div className="ac-shell ac-cta__inner">
          <div><p className="ac-kicker">ARMAT CONTROL</p><h2>Más control.<br/>Más información.<br/>
          <span>Mejores decisiones.</span></h2><p>Conocé cómo Armat Control puede mejorar la gestión de accesos de tu organización.</p></div>
          <div className="ac-cta__actions"><a className="ac-btn" href={`mailto:info@armatseguridad.com?subject=${encodeURIComponent('Control de accesos')}`} target="_blank" rel="noreferrer">SOLICITAR DEMO →</a></div>
        </div>
      </section>
    </main>
  </>
  );
}
